(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["watch-enquiry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('standler-watch-enquiry')) {
    customElements.define('standler-watch-enquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.select = this.querySelector('[data-watch-variant]');
        this.querySelector('[data-watch-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-watch-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.select?.addEventListener('change', () => {
          this.sync();
          const url = new URL(location.href);
          if (url.pathname === this.dataset.productUrl) {
            url.searchParams.set('variant', this.select.value);
            history.replaceState({}, '', url);
          }
        });
        this.sync();
        if (this.querySelector('[data-watch-result]') || location.hash === '#enquire') this.open();
      }
      sync() {
        const option = this.select?.selectedOptions[0];
        const details = option?.dataset.options || '';
        this.querySelector('[data-watch-summary]').textContent = details;
        const id = this.querySelector('[data-watch-variant-id]');
        if (id && option) id.value = option.value;
        const sku = this.querySelector('[data-watch-sku]');
        if (sku && option) sku.value = option.dataset.sku || '';
        const options = this.querySelector('[data-watch-options]');
        if (options && option) options.value = details;
      }
      open() {
        this.sync();
        if (!this.dialog.open) this.dialog.showModal();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
